import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';

import { GlobalRulesTab } from '@/features/workbench/settings/GlobalRulesTab';
import { useLocalize } from '@/hooks/use-localize';
import { Button } from '@/ui/Button';

export const Route = createFileRoute('/_protected/t/$tenantId/workbench/settings')({
  component: WorkbenchSettingsRoute,
});

function WorkbenchSettingsRoute() {
  const navigate = useNavigate();
  const { tenantId } = Route.useParams();
  const { tLocalize } = useLocalize();

  return (
    <div className="flex size-full flex-col">
      <div className="flex items-center gap-4 border-b border-white/10 p-6">
        <Button
          variant="ghost"
          size="sm"
          aria-label={tLocalize('editor.workbench.settings.backAriaLabel')}
          onClick={() => navigate({ to: '/t/$tenantId/workbench', params: { tenantId } })}
          className="text-gray-400 hover:text-gray-200"
        >
          <ArrowLeft className="size-4" />
        </Button>
        <h1 className="text-2xl font-semibold text-gray-100">{tLocalize('editor.workbench.settings.title')}</h1>
      </div>

      <div className="flex-1 overflow-auto p-6">
        <GlobalRulesTab />
      </div>
    </div>
  );
}
